import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchEnteredAnswersList = (formsTypes) => {
  return apiActionCreator({
    'endpoint': `/answers/notPublished?formsTypes=${formsTypes}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ENTERED_ANSWERS_LIST,
      ActionTypes.FETCHED_ENTERED_ANSWERS_LIST,
      [
        ActionTypes.FETCHED_ENTERED_ANSWERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });
};
